import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './HomePage.css';
import { useAuth } from '../../AuthContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const HomePage: React.FC = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    const logoutPromise = new Promise<void>((resolve) => {
      setTimeout(() => {
        logout();
        resolve();
      }, 500);
    });

    toast.promise(
      logoutPromise,
      {
        pending: 'Abmeldung läuft...',
        success: 'Sie wurden erfolgreich abgemeldet.',
        error: 'Fehler bei der Abmeldung.'
      }
    ).then(() => {
      navigate('/', { replace: true });
      window.scroll(0, 0);
    });
  };

  return (
    <>
      <div className="welcome-container">
        <h2 className="welcome">Herzlich willkommen zur</h2>
        <h1 className="welcome">IMC Nostrifizierungs-Plattform!</h1>
        <p className="welcome">Die IMC Nostrifizierungs-Plattform ist die zentrale Kommunikationsplattform während Ihres Nostrifizierungsverfahrens.</p>
      </div>
      {isAuthenticated === false ? (
        <>
          <div className="homepage-container">
            <h1 className="homepage-title">Registrierung und Anmeldung</h1>
            <p className="homepage-subtitle">
              Durch die Registrierung erstellen Sie Ihr Benutzerkonto und legen Ihre Zugangsdaten fest.
              Danach können Sie sich mit diesen Zugangsdaten jederzeit auf der IMC Nostrifizierungs-Plattform anmelden.
            </p>

            <div className='homepage-sections'>
              <div className="homepage-section-gr">
                <h2>Neue Registrierung</h2>
                <p>Reichen Sie mit Ihrer Registrierung einen neuen Nostrifzierungs-Antrag ein.</p>
                <div className="homepage-section-content ">
                  <Link to="/register" className="homepage-button" onClick={() => window.scroll(0, 0)}>Jetzt registrieren</Link>
                </div>
              </div>
              <div className="homepage-section">
                <h2>Bereits registriert?</h2>
                <p>Steigen Sie mit Ihren Zugangsdaten in die IMC Nostrifizierungs-Plattform ein.</p>
                <div className="homepage-section-content">
                  <Link to="/login" className="homepage-button" onClick={() => window.scroll(0, 0)}>Jetzt anmelden</Link>
                </div>
              </div>
            </div>
            <div className="agency-registration">
              <h2 style={{ marginBottom: 15 }}>Registrierung für Agenturen</h2>
              <p>
                Wenn Sie als Agentur Anträge einreichen möchten, kontaktieren Sie uns bitte per E-Mail an <a href="mailto:nostrifizierung@imc.ac.at" style={{ fontWeight: 'bold', textDecoration: 'none', color: 'white' }}>nostrifizierung@imc.ac.at</a>.<br />
                Nach Prüfung Ihrer Anfrage erhalten Sie einen persönlichen Zugang zur Plattform.
              </p>
            </div>
          </div>
        </>
      )
        :
        (
          <>
            <div className="homepage-container">
              <h1 className="homepage-title">Anmeldung erfolgreich!</h1>
              <p className="homepage-subtitle">
                Sie können jetzt im Dashboard weiterarbeiten und Ihre Anträge verwalten.
              </p>
              <div className="homepage-sections">
                <div className="homepage-section-gr">
                  <h2>Dashboard</h2>
                  <p>Öffnen Sie das Dashboard, um neue Anträge einzureichen und den Status Ihrer bestehenden Anträge zu überprüfen.</p>
                  <div className="homepage-section-content">
                    <Link to="/dashboard" className="homepage-button" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }
                    }>
                      Dashboard</Link>
                    {/* <img src={dashboardImg} alt="Dashboard" className="homepage-image3" /> */}
                  </div>
                </div>
                <div className="homepage-section">
                  <h2>Abmelden</h2>
                  <p>Klicken Sie auf die Schaltfläche, um sich von Ihrem Konto abzumelden.</p>
                  <div className="homepage-section-content">
                    <button onClick={handleLogout} className="homepage-button">Abmelden</button>
                    {/* <img src={personWalkingImg} alt="Logout" className="homepage-image2" /> */}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

    </>
  );
};

export default HomePage;
